import { useState, useEffect } from 'react'

type LocalStorageHookValue<T> = [T | null, (value: T) => void];

export function useLocalStorage<T>(key: string, initialValue?: T): LocalStorageHookValue<T> {
    const [storedValue, setStoredValue] = useState<T | null>(() => {
        try {
            const item = localStorage.getItem(key)
            return item !== null ? JSON.parse(item) : initialValue
        } catch (error) {
            console.error('Error reading from localStorage:', error)
            return initialValue
        }
    })

    useEffect(() => {
        try {
            const item = localStorage.getItem(key)
            if (item !== null) {
                setStoredValue(JSON.parse(item))
            }
        } catch (error) {
            console.error('Error reading from localStorage:', error)
        }
    }, [key])

    const setValue = (value: T): void => {
        try {
            localStorage.setItem(key, JSON.stringify(value))
            setStoredValue(value)
        } catch (error) {
            console.error('Error writing to localStorage:', error)
        }
    }

    return [storedValue, setValue]
}
